@if (authorization && form) {
  <div class="col-24 grow"
    [formGroup]="form" iczAutoFocus
    [waiting]="loadingService.isLoading(this)"
  >
    @let document = $any(documentDetailService.object);

    @if (document?.fileId) {
      <icz-object-association-alert
        heading="Dokument je vložen do spisu"
        [associatedObjectClass]="file?.objectClass ?? ObjectClass.FILE"
      >
        <ng-container afterHeading>
          @if (!isFileUnavailable && file) {
            <icz-ref-number-link
              [entity]="getFileEntity(file)"
              [isConstrainedView]="!isAuthorizedOperationGranted(file.authorization, FileAuthorizedOperation.FILE_SHOW_PROFILE)"
            ></icz-ref-number-link>
            @if (file.subject) {
              ({{file.subject}})
            }
            @if (document.orderNumberInFile) {
              {{ 'v pořadí' | translate }} {{ document.orderNumberInFile }}
            }
          }
        </ng-container>
      </icz-object-association-alert>

      @if (file?.caseFile) {
        <icz-case-file-association-alert
          class="mt--8"
          [parentEntityType]="document.entityType!"
          [caseFileInfo]="caseFileInfo"
          [isCaseFileInfoUnavailable]="isCaseFileInfoUnavailable"
        ></icz-case-file-association-alert>
      }
    }
    @if (document?.storageUnitId) {
      <icz-storage-unit-association-alert
        [class.mt--8]="file"
        [parentEntityType]="document.entityType!"
        [storageUnit]="storageUnit"
        [isStorageUnitUnavailable]="isStorageUnitUnavailable"
      ></icz-storage-unit-association-alert>
    }
    <icz-section [label]="('Číslo jednací' | translate) + ': ' + refNumberValue" boxed>
      <ng-container sectionHeader>
        @if ((document$ | async)?.refNumber; as refNumber) {
          <icz-copy-to-clipboard-button
            size="small"
            [text]="refNumber"
          ></icz-copy-to-clipboard-button>
        }
      </ng-container>
      <icz-document-registration-timeline-link sectionHeaderAppendix [document]="$any(document$ | async)"></icz-document-registration-timeline-link>
      <div class="row">
        <icz-form-field class="grow-2" label="Věc" formControlName="subject" [autoSizeMax]="3"></icz-form-field>
        <ng-container formGroupName="uid">
          <icz-form-field label="UID - Unikátní identifikátor" formControlName="uid" class="grow"></icz-form-field>
        </ng-container>
      </div>
      <div class="row">
        <icz-form-field class="grow-2" label="Popis" formControlName="description" [autoSizeMax]="6"></icz-form-field>
        <div class="row grow">
          <icz-form-field class="grow" label="Značka" formControlName="label"></icz-form-field>
          <icz-form-autocomplete class="grow" label="Forma" formControlName="documentForm"
          [clearable]="false" [options]="documentFormOptions"></icz-form-autocomplete>
        </div>
      </div>
      <div class="row">
        <icz-form-field class="grow-2" label="Poznámka" formControlName="note" [autoSizeMax]="6"></icz-form-field>
        <div class="row grow">
          <icz-form-autocomplete class="grow" label="Stav" formControlName="documentState" [options]="documentStateOptions"></icz-form-autocomplete>
          <icz-date-picker formControlName="resolutionDate"
            [iczPassedDeadlineWarning]="deadlineWarning"
            label="Termín vyřízení" class="grow" outputFormat="dateTime">
          </icz-date-picker>
        </div>
      </div>
      <div class="row">
        <icz-form-autocomplete class="grow" label="Držitelé" formControlName="holderFunctionalPositionIds" [isMultiselect]="true"
        [autoSizeMax]="6" [options]="functionalPositionOptions$ | async"></icz-form-autocomplete>
        <icz-form-autocomplete class="grow owner-field" label="Zpracovatel" formControlName="ownerFunctionalPositionId"
        [autoSizeMax]="6" [options]="functionalPositionOptions$ | async"></icz-form-autocomplete>
      </div>
    </icz-section>
    <div class="row-24 pb-64 grow">
      <div class="col-24 grow">
        @if (isDocumentSettled) {
          <icz-section label="Vyřízení dokumentu" boxed>
            <icz-form-autocomplete class="grow-3" label="Kdo vyřídil" formControlName="settlementFunctionalPositionId"
            [options]="functionalPositionOptions$ | async"></icz-form-autocomplete>
            <div class="row">
              <icz-date-picker label="Datum vyřízení" class="grow" formControlName="settlementDate"></icz-date-picker>
              @if (settlementType === SettlementType.BY_OTHER_METHOD) {
                <icz-form-field [fieldDisabled]="true" label="Způsob vyřízení" [value]="otherSettlementMethod" class="grow"></icz-form-field>
              } @else {
                <icz-form-autocomplete label="Způsob vyřízení" class="grow" formControlName="settlementType" [options]="documentSettlementTypeOptions"></icz-form-autocomplete>
              }
            </div>
            @if (settledByDocument) {
              <div>
                <icz-label class="icz-body-1" label="Vyřizující dokument"></icz-label>
                <icz-entity-item
                  [entity]="settledByDocument"
                ></icz-entity-item>
              </div>
            }
            @if (settlementType === SettlementType.BY_RECORD) {
              <icz-form-field formControlName="settlementReason" label="Důvod vyřízení"></icz-form-field>
              <icz-form-field formControlName="settlementContent" label="Obsah vyřízení"></icz-form-field>
            }
          </icz-section>
          <icz-section label="Vyřazení" boxed>
            <div class="row">
              <icz-form-field class="grow" formControlName="disposalYear" label="Rok vyřazení podle skartačního režimu"></icz-form-field>
              <icz-form-field class="grow" formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
            </div>
          </icz-section>
        }
        @if (isInExternalApplication) {
          <icz-section label="Zpracování v externí aplikaci" boxed>
            <icz-form-autocomplete label="Externí aplikace" formControlName="issdId"
            [options]="issdApplicationOptions$ | async"></icz-form-autocomplete>
          </icz-section>
        }
        @if (canShowDocumentComponents || objectExistenceComponentsVisible) {
          <icz-section label="Komponenty" boxed>
            @if (loadingService.isLoading$(this, DocumentDetailPreviewLoaderId.DOCUMENT_COMPONENTS) | async) {
              <div class="text-center">
                <icz-spinner class="inline-block mt-8" [diameter]="30"></icz-spinner>
              </div>
            }
            @else {
              <div class="mx--24" [class.card-divider]="componentsCount > PREVIEW_COMPONENTS_TO_SHOW">
                @for (component of documentComponents; track component.id) {
                  <icz-essl-component-link
                    class="block mx-24 my-8"
                    [documentEsslComponent]="component"
                    [isReadonly]="isDocumentDeactivated"
                    [skipOpenComponentViewer]="!canShowDocumentComponents && objectExistenceComponentsVisible"
                    (metadataChanged)="onComponentMetadataChange()"
                  ></icz-essl-component-link>
                }
              </div>
            }
            @if (componentsCount > PREVIEW_COMPONENTS_TO_SHOW) {
              <icz-button
                size="xlarge" [label]="('Všechny komponenty' | translate) + ' (' + componentsCount + ')'"
                (onAction)="navigateToComponents()" transparent
                class="mx--24 mb--16"
              ></icz-button>
            }
          </icz-section>
        }
        @if (canShowDocumentProfile || applicationConfigService.objectExistenceCheckObjectRepresentingSubjectVisible()) {
          <icz-section label="Reprezentující subjekt" boxed>
            <icz-portrait [subject]="representingSubject$ | async" [object]="document$ | async" [showDatabox]="true"></icz-portrait>
          </icz-section>
        }
        <icz-section label="Třídění" boxed>
          <icz-document-type-selector
            class="grow"
            [form]="form"
            controlName="documentTypeId"
            [showPopupDetails]="true"
          ></icz-document-type-selector>
          <icz-entity-class-selector
            [form]="form"
            controlName="entityClassId"
            [selectorEntityClassType]="fileId ? null : EntityClassType.DOCUMENT_FILE"
            [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITHOUT_V"
            [showPopupDetails]="true"
          ></icz-entity-class-selector>
          <icz-disposal-schedule-retention-trigger-widget
            [entityClassId]="entityClassId"
            [documentTypeId]="documentTypeId"
            [useValuesFromForm]="isDocumentSettled"
            [retentionTriggerWidgetMode]="retentionTriggerValidationMode"
            (externalRetentionTriggerIdSourceSelected)="onExternalRetentionIdSelected($event)"
            [form]="form"
          ></icz-disposal-schedule-retention-trigger-widget>
        </icz-section>
      </div>
      <div class="col-24 grow">
        @if(isDocumentRegisteredExternally) {
          <icz-section label="Přeevidováno do externí evidence" boxed>
            <icz-form-field [fieldDisabled]="true" label="Datum a čas přeevidování"  [value]="externalRegistryMoveDate | localizedDatetime"></icz-form-field>
            <icz-form-field label="Důvod přeevidování" formControlName="externalRegisterMoveReason"></icz-form-field>
          </icz-section>
        }
        <icz-section label="Základní informace" boxed>
          <icz-form-field label="Související evidence" formControlName="relatedEvidence"></icz-form-field>
          <div class="row">
            <ng-container formGroupName="auditInfo">
              <icz-date-picker label="Založeno" class="grow" formControlName="createdAt"></icz-date-picker>
              <icz-date-picker label="Poslední úprava" formControlName="modifiedAt" class="grow"></icz-date-picker>
            </ng-container>
          </div>
          <icz-form-autocomplete label="Evidenční pomůcka" class="grow" formControlName="filingRegisterId" [options]="basicRegisterOptions"></icz-form-autocomplete>
          <icz-date-picker label="Poslední datum evidence" class="grow" formControlName="filingRegisterRegDate"></icz-date-picker>
          @if (isReceivedDocument) {
            <icz-form-field label="Číslo jednací odesílatele" formControlName="senderRefNr"></icz-form-field>
          }
          @if (isDocumentDeactivated) {
            <icz-form-field [fieldDisabled]="true" label="Zrušil" [value]="auditInfo.modifiedByFunctionalPositionId | findFunctionalPositionById | async"></icz-form-field>
            <ng-container formGroupName="deactivateAuditInfo">
              <icz-date-picker formControlName="deactivationDate"
                               label="Datum zrušení"  outputFormat="dateTime">
              </icz-date-picker>
              <icz-form-field label="Důvod zrušení" formControlName="deactivationReason"></icz-form-field>
            </ng-container>
          }
        </icz-section>
        @if (isDocumentLost) {
          <icz-section label="Záznam o ztrátě" boxed>
            <icz-form-field label="Důvod ztráty" formControlName="lossReason"></icz-form-field>
            <icz-date-picker formControlName="lossDate"
                             label="Datum zjištění ztráty"  outputFormat="dateTime">
            </icz-date-picker>
            @if (loadingService.isLoading(this, LOSS_RECORD_LOADING)) {
              <icz-spinner [diameter]="24"></icz-spinner>
            } @else {
              <icz-entity-item
                [entity]="lostRecordDocument"
              ></icz-entity-item>
            }
          </icz-section>
        }

        <icz-section label="Specifické" boxed>
          <icz-security-category-selector
            [form]="form"
            controlName="securityCategoryId"
          ></icz-security-category-selector>
          <icz-keywords-selector [form]="form" controlName="keywordIds"></icz-keywords-selector>
          <icz-document-file-custom-fields-section
            [form]="form"
            [entityTypes]="[entityType]"
            [documentTypeId]="documentTypeId"
            [validityReferenceDate]="customFieldsValidityReferenceDate"
            [customFieldIdForChanges]="customFieldIdToWatch"
            (customFieldValueChange)="onCustomFieldValueChange($event)"
          ></icz-document-file-custom-fields-section>
        </icz-section>
        <icz-section label="Právní moc a zmocnění" boxed>
          <icz-date-picker formControlName="executionDate" label="Právní moc" class="grow" outputFormat="dateTime"></icz-date-picker>
          <icz-empowerment formControlName="empowerment"></icz-empowerment>
        </icz-section>
        @if (isInRegistryOffice) {
          <icz-object-detail-preview-transfer-info-section
            [transferWithMainEntity]="registryOfficeTransfer!"
          ></icz-object-detail-preview-transfer-info-section>
        }
        <icz-section label="Fyzické uložení" boxed>
          <icz-form-field formControlName="componentPhysicalLocation" label="Uložení" class="grow"></icz-form-field>
        </icz-section>
        <icz-essl-component-counts [form]="form" [boxed]="true"></icz-essl-component-counts>
      </div>
    </div>
  </div>
}
